import React from "react";
import Maintenances from "../../components/browser/Maintenances";

import { useParams } from "react-router";

const PageMaintenance = () => {
    const params = useParams();

    return <Maintenances hasSummary carNumber={params.id} />;
};

export default PageMaintenance;
